import Sidebar from './SideBar.vue'

const SidebarStore = {
    showSidebar: false,
    sidebarLinks: [
        {
            name: 'home',
            icon: 'ti-panel',
            path: '/home'
        }
    ],
    displaySidebar (value) {
        this.showSidebar = value
    }
}

const SidebarPlugin = {

    install (Vue) {
        Vue.mixin({
            data () {
                return {
                    sidebarStore: SidebarStore
                }
            }
        })

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get () {
                return this.$root.sidebarStore
            }
        })
        Vue.component('side-bar', Sidebar)
    }
}

export default SidebarPlugin



// WEBPACK FOOTER //
// ./src/components/Shared/SidebarPlugin/index.js